<template>
  <div class="module" :id="moduleData.itemCode" style="padding-bottom: 20px;">
    <div class="module-label">
      {{moduleData.itemName}}
    </div>
    <div style="padding: 0 25px 0 19px;">
      <TFSBasicForm
        :attrs="list"
        v-bind.sync="commonProps"
        :currentData="formInfo[moduleData.itemCode]"
        :getList="!!(moduleData.mappingExtend && moduleData.mappingExtend.getList)"
        ref="TFSBasicForm"></TFSBasicForm>
    </div>
  </div>
</template>

<script>
import {applyMixins} from "src/components/application/components/mixin";
import TFSBasicForm from "src/components/application/components/TFSBasicForm.vue";

/**
 * type 0 填写 1 日期 2 下拉 3 checkbox 10 按钮 11 json表单
 * */
export default {
  name: "TFSCommonForm",
  mixins: [applyMixins],
  components: {TFSBasicForm},
  data() {
    return {
      form: {},
      rules: {},
      list: [],
      configInit: false,
      getList: false,
      formByCode: {}
    }
  },
  watch: {
    formConfig: {
      handler(val) {
        if (!val.length) return
        const configObj = val.find(v => v.areaCode === this.moduleData.itemCode) || {}
        this.list = JSON.parse(JSON.stringify(configObj.attrs || []))
      },
      immediate: true
    },
    formInfo: {
      handler(val) {
      },
      immediate: true
    }
  },
  methods: {
    getValidate() {
      const data = this.$refs.TFSBasicForm.getValidate()
      data[this.moduleData.itemCode] = data.list
      this.$emit('input', JSON.parse(JSON.stringify(data)))
      return data.validator
    },
  }
}
</script>

<style scoped lang="scss">
</style>